<template>
  <div class="content">
    <h2>Billing</h2>
    <p> Paying with <b>{{cardBrand}} .... {{cardLastNumber}}</b>.<br>
        Subscription will automatically renew on {{formatRenewDate}}. </p>
    <ButtonNew class="button" mode="green" size="l" text="Edit card" @click="$emit('edit-card')"/>
  </div>
</template>

<script>
import ButtonNew from "@/components/UI-Kit/ButtonNew";
import moment from 'moment'
import {computed} from 'vue'

export default {
  name: "Billing",
  components: {
    ButtonNew
  },
  props: {
    cardBrand: String,
    cardLastNumber: Number,
    renewDate: String
  },
  setup(props) {
    const formatRenewDate = computed(() => moment(props.renewDate).format('MMM DD, YYYY'))
    return {
      formatRenewDate
    }
  }
};
</script>

<style scoped lang="sass">
@import "~@/assets/styles/color-scheme.scss"
.content
    text-align: left
    padding: 16px
    margin-bottom: 24px
    background-color: #fff
    box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.1)
    border-radius: 8px
h2
    margin-bottom: 16px
p 
    margin-bottom: 16px
.button
    margin-right: 8px
</style>